import { render, staticRenderFns } from "./viewAttachmentsPopUp.vue?vue&type=template&id=0881c5fe&scoped=true&"
import script from "./viewAttachmentsPopUp.vue?vue&type=script&lang=ts&"
export * from "./viewAttachmentsPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./viewAttachmentsPopUp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./viewAttachmentsPopUp.vue?vue&type=style&index=1&id=0881c5fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881c5fe",
  null
  
)

export default component.exports